import { useEffect, useState } from 'react';
import { api } from '../api';
import { useCapa } from './navegacionReact';

// EL AVISO DE PRIVACIDAD Y LOS TÉRMINOS, DESDE LA PUERTA · criterio 5.4.
//
// Van en el inicio de sesión porque ahí es donde alguien decide si
// acepta las condiciones, y en ese momento todavía no tiene sesión. Una
// página legal detrás de un login es una página que nadie lee antes de
// aceptar.
//
// SI SIGUEN SIENDO BORRADOR, SE DICE AQUÍ MISMO. La directriz pide un
// «marcador visible» mientras no exista el texto del dueño, y visible
// quiere decir en la puerta — no dentro del documento, donde solo lo ve
// quien ya hizo clic.
export default function EnlacesLegales() {
  const [indice, setIndice] = useState(null);
  const [abierto, setAbierto] = useState(null);
  useCapa(!!abierto, () => setAbierto(null));      // el documento abierto: atrás lo cierra

  useEffect(() => {
    let vivo = true;
    api.get('/legal')
      .then((d) => vivo && setIndice(d))
      .catch(() => {});
    return () => { vivo = false; };
  }, []);

  if (!indice) return null;

  const abrir = (clave) => {
    api.get(`/legal/${clave}`).then(setAbierto).catch(() => {});
  };

  // SOLO LOS DE LA PUERTA. Aquí se enseña lo que alguien está aceptando
  // al entrar; el aviso que el cliente le da a su propio personal es una
  // plantilla suya y vive en «Terminales de conteo», que es donde la va
  // a buscar quien la necesita.
  //
  // EL FILTRO ES DEL SERVIDOR, no una lista de claves escrita aquí: si
  // fuera de aquí, un documento nuevo aparecería en la puerta por
  // omisión — y la puerta es la única página sin sesión.
  const enLaPuerta = indice.documentos.filter((d) => d.en_la_puerta);
  if (!enLaPuerta.length) return null;

  return (
    <>
      <p className="text-xs text-[var(--p-sobre-noche-2)]">
        {enLaPuerta.map((d, i) => (
          <span key={d.clave}>
            {i > 0 && <span aria-hidden="true"> · </span>}
            <button
              type="button"
              onClick={() => abrir(d.clave)}
              className="underline underline-offset-2 hover:opacity-80"
            >
              {d.titulo}
            </button>
          </span>
        ))}
      </p>

      {indice.hay_borradores && (
        <p className="mt-1 text-xs font-semibold text-amber-300">
          Todavía en borrador: no sirven como aviso legal.
        </p>
      )}

      {abierto && (
        <div
          role="dialog"
          aria-label={abierto.titulo}
          className="fixed inset-0 z-50 flex items-center justify-center
                     bg-black/60 p-4"
        >
          <div className="max-h-[85vh] w-full max-w-2xl overflow-auto
                          rounded-xl bg-white p-5 text-gray-800">
            <div className="flex items-start justify-between gap-3">
              <h2 className="text-lg font-semibold text-gray-900">
                {abierto.titulo}
              </h2>
              <button
                type="button"
                onClick={() => setAbierto(null)}
                className="text-sm font-semibold text-[var(--color-marca)]"
              >
                Cerrar
              </button>
            </div>

            {abierto.borrador && (
              <p className="mt-3 rounded-lg border border-red-300 bg-red-50
                            p-3 text-sm font-semibold text-red-800">
                {abierto.aviso}
              </p>
            )}
            {abierto.vigencia && (
              <p className="mt-2 text-xs text-gray-500">
                Vigente desde {abierto.vigencia}.
              </p>
            )}

            {/* SIN INTÉRPRETE DE MARKDOWN. El texto se enseña tal cual,
                con sus saltos de línea. Meter una biblioteca que
                convierta texto de un archivo en HTML para pintarlo en la
                pantalla de acceso —la única página sin sesión— es
                superficie nueva a cambio de unas negritas. */}
            <pre className="mt-3 whitespace-pre-wrap font-sans text-sm
                            leading-relaxed text-gray-700">
              {abierto.texto}
            </pre>
          </div>
        </div>
      )}
    </>
  );
}
